<template>
  <div class="dsf_nc_special_detail_course_item">
    <ul class="nc_detail_wrap" v-if="lists.length">
      <li class="nc_detail_item" v-for="(item, index) in lists" :key="index">
        <div class="detail_top">
          <div class="item_title">{{ item.unitName }}</div>
          <div class="item_top_right">
            <span>选修：{{ item.electives || 0 }} 门</span>
            <span>{{ item.electivesPeriod || 0 }} 学时</span>
            <span>必修：{{ item.compulsory || 0 }} 门</span>
            <span>{{ item.compulsoryPeriod || 0 }} 学时</span>
            <span class="icon iconfont icon-xia1 sq" @click="clickFold(index)" v-if="item.fold"></span>
            <span class="icon iconfont icon-shang1 sq" @click="clickFold(index)" v-if="!item.fold"></span>
          </div>
        </div>
        <div class="detail_desc" v-if="item.fold">
          <div class="detail_desc_item" v-for="(items, idx) in item.subList" :key="items.subId">
            <div class="detail_desc_left">
              <i :class="`icon iconfont ${setIcon(items.typeValue)}`"></i>
              <span class="type_name">{{ items.typeText }}</span>
              <span :class="`type_category ${items.categoryText == '必修' ? 'bx' : 'xx'}`">{{ items.categoryText }}</span>
              <span class="detail_name">{{ items.name }}</span>
            </div>
            <div class="detail_desc_right">
              <div class="detail_time font">{{ items.duration }}</div>
              <!-- <div class="wcxs font">{{ items.period || 0 }}学时</div> -->
              <div class="wcxs font">{{ items.teacher || "" }}</div>
              <div class="progress">
                <el-progress :percentage="items.progress || 0" stroke-width="11" :show-text="false"></el-progress>
                <span class="pivot-txt">{{ items.progress || 0 }}%</span>
              </div>
              <!-- (showClick && item.orderTypeValue == '1' && idx > 0 && item.subList[idx - 1].progress == 100) ||
                  (showClick && item.orderTypeValue == '1' && idx == 0) ||
                  (showClick && item.orderTypeValue == '0') ||
                  (showClick && item.orderTypeValue == '1' && items.progress == 100) ||
                  detailData.state == 3 -->
              <!-- 当前是否有设置看课限制 true可以看 false不可看： items.playState  -->
              <div
                class="enter_btn"
                :style="`${itemStatus(items, item, idx, idx > 0 ? item.subList[idx - 1].progress : null) && items.playState ? '' : 'background: #aaa; cursor: default'}`"
                @click="showClick && items.playState && clickEnter(items, item.classId, item, idx, idx > 0 ? item.subList[idx - 1].progress : null)"
              >
                进入
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="no_data" v-else>
      <!-- 暂无数据 -->
      <!-- <dsf-image :src="''" /> -->
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  name: "dsfNcSpecialDetailCourseItem",
  props: {
    lists: {
      type: Array,
      default: () => {
        return [];
      },
    },
    detailData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showClick: false,
      isCanClick: false,
    };
  },
  methods: {
    clickFold(index) {
      this.lists[index]["fold"] = !this.lists[index]["fold"];
    },
    itemStatus(item, parentItem, childIndex, lastProgress) {
      // 能点击 &&  当前单元没有设置排序
      if (this.showClick && parentItem.orderTypeValue == "0") return true;
      // 能点击 && 当前单元设置了排序 && 不是第一节课 && 上个进度为100
      if (this.showClick && parentItem.orderTypeValue == "1" && childIndex > 0 && lastProgress == 100) return true;
      //能点击 && 当前单元设置了排序 && 当前是第一节课
      if (this.showClick && parentItem.orderTypeValue == "1" && childIndex == 0) return true;
      // 能点击 &&  当前单元设置了排序 && 当前进度100
      if (this.showClick && parentItem.orderTypeValue == "1" && item.progress == 100) return true;
      //  状态为结业
      if (this.detailData.state == 3) return true;

      return false;
    },
    clickEnter(item, specialId, parentItem, childIndex, lastProgress) {
      let statues = this.itemStatus(item, parentItem, childIndex, lastProgress);
      if (!statues) return;
      // 点击进入
      let type = item.typeValue;
      let classid = specialId; // 专题班id
      let id = item.businessId; // 课程id;考试id

      let url = "";

      switch (type) {
        case "course": // 课程
          url = `/page.html#/pc/nc/pagecourse/coursePlayer?id=${id}&classid=${classid}&type=ztb`;
          break;
        case "video": // 视频
          url = `/page.html#/pc/nc/pagecourse/coursePlayer?id=${id}&classid=${classid}&type=ztb`;
          break;
        case "audio": // 音频
          url = `/page.html#/pc/nc/pagecourse/coursePlayer?id=${id}&classid=${classid}&type=ztb`;
          break;
        case "draft": // 文稿
          url = `/page.html#/pc/nc/pagecourse/coursePlayer?id=${id}&classid=${classid}&type=ztb`;
          break;
        case "media": // 富媒体
          url = `/page.html#/pc/nc/pagecourse/coursePlayer?id=${id}&classid=${classid}&type=ztb`;
          break;
        case "live": // 直播
          url = `/page.html#/pc/nc/pagelive/liveDetail?id=${id}`;
          break;
        case "exam": // 考试
          this.toExamDetail(item, specialId);
          break;
        default:
          break;
      }

      // if (parentItem.orderTypeValue == "1" && lastProgress != 100 && childIndex > 0 && item.progress != 100) {
      //   return;
      // }

      this.$open({ url, state: 2 });
    },
    toExamDetail(item) {
      const loading = dsf.layer.loading();
      /**
       * @param businessType 专题班1 考核2 单元考试1 任务考试 3
       * @param deviceType pc mobile
       */
      let params = {
        examId: item["businessId"], //考试id
        businessId: item["subId"], //业务id
        businessType: 1,
        deviceType: "pc",
      };
      this.dsf.http
        .get("ncexam/api/getExamUrl", params, $$webRoot.nc)
        .done(res => {
          if (res.success) {
            const path = dsf.url.getWebPath(res.data, $$webRoot.exam);
            // window.open(path);
            this.$open({ url: `${location.origin + path}`, state: 2 });
          } else {
            dsf.layer.message(res.message || "获取考试异常", false);
          }
        })
        .error(err => {
          dsf.layer.message(err.message || "获取考试异常", false);
        })
        .always(function () {
          dsf.layer.closeLoading(loading);
        });
    },
    setIcon(status) {
      let iconText = "";
      switch (status) {
        case "course" || "video" || "audio":
          iconText = "icon-shipin1";
          break;
        case "draft":
          iconText = "icon-wengao-1";
          break;
        case "live":
          iconText = "icon-a-zhibobofangshexiangjitianxianmianxing";
          break;
        case "exam":
          iconText = "icon-kaoshi";
          break;
        case "media":
          iconText = "icon-fumeitixiaoxi";
          break;
        default:
          iconText = "";
      }
      return iconText;
    },
  },
  watch: {
    lists: {
      handler(val) {
        val.forEach(element => {
          this.$set(element, "fold", true);
        });
      },
      immediate: true,
    },
    detailData: {
      handler(val) {
        // console.log(136136, val);
        if ((val.state == 2 && val.trainingStatus == 1) || val.state === 3) {
          this.showClick = true;
        } else {
          this.showClick = false;
        }
      },
      immediate: true,
    },
  },
};
</script>
